const studyRouter = () => {
    return [
        {
            path: 'study-v',
            name: 'study-v',
            component: () => import(/* webpackChunkName: "study" */'../../modules/study/index.vue')
        }
    ];
};
export default studyRouter;
